module.exports = __webpack_public_path__ + "dd3c06bea5c5c1c06f1d6fcf242a4ef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_star_white_2x.png
// module id = 129
// module chunks = 0 1 2 3 4